import { RegisterItem } from '@core/entities/register/RegisterItem'
import { Flex } from '@fundamentals'
import { Chip } from '@mui/material'
import { useRegisterContext } from '@modules/registers/details/RegisterContext'
import { PageUrls } from '@core/page-urls'
import { statuses } from '@core/theme/statuses'

type RegisterItemPropertyScheduleInspectionValueProps = {
  registerItem: RegisterItem
  onInspectionClick?: () => void
}

export const RegisterItemPropertyScheduleInspectionValue: React.FC<
  RegisterItemPropertyScheduleInspectionValueProps
> = ({ registerItem, onInspectionClick }) => {
  const activeInspectionsCount = registerItem.getActiveInspectionsCount()
  const overdueInspectionsCount = registerItem.getOverdueInspectionsCount()
  const { scope, registerId } = useRegisterContext()

  const handleChipClick = () => {
    if (onInspectionClick) {
      onInspectionClick()
    } else if (registerItem.id) {
      window.open(
        PageUrls.registerItemDetails({
          organisationId: scope.organisationId,
          registerId,
          registerItemId: registerItem.id,
          tab: 'inspections',
        }),
      )
    }
  }
  return (
    <Flex gap={1}>
      {activeInspectionsCount && (
        <Chip
          variant='outlined'
          label={activeInspectionsCount}
          size='small'
          onClick={handleChipClick}
        />
      )}
      {!!overdueInspectionsCount && (
        <Chip
          label={`${statuses.overdue.label} (${overdueInspectionsCount})`}
          size='small'
          onClick={handleChipClick}
          color={statuses.overdue.color}
        />
      )}
    </Flex>
  )
}
